// extracted by mini-css-extract-plugin
var _1 = "q5Ktt";
var _2 = "UtMIJ";
var _3 = "RU1r4";
var _4 = "UcYAM";
var _5 = "ANBBW";
var _6 = "EsEGO";
export { _1 as "banner", _2 as "banner-icon", _3 as "banner-icon-close", _4 as "variant-error", _5 as "variant-info", _6 as "variant-warning" }
